module.exports = __webpack_public_path__ + "img/PSD.06ce6aab.svg";